import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const SETTINGS_DOC_ID = 'global';
const SETTINGS_COLLECTION = 'settings';

export const getSiteSettings = async () => {
  try {
    const docRef = doc(db, SETTINGS_COLLECTION, SETTINGS_DOC_ID);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      // Default settings if none exist
      return {
        siteTitle: 'أسعار الذهب',
        siteDescription: 'متابعة أسعار الذهب لحظة بلحظة مع التحليلات والأخبار.',
      };
    }
  } catch (error) {
    console.error('Error fetching settings:', error);
    return null;
  }
};

export const updateSiteSettings = async (settingsData) => {
  try {
    await setDoc(doc(db, SETTINGS_COLLECTION, SETTINGS_DOC_ID), settingsData, { merge: true });
    return true;
  } catch (error) {
    console.error('Error updating settings:', error);
    return false;
  }
};
